<template>
  <div class="success-container g-flex-c">
    <img v-if="qrStatus === 2" src="../../../assets/image/success.png" alt="">
    <img v-else src="../../../assets/image/fail.png" alt="">
    <p class="first">{{ `报名${qrStatus === 2 ? '成功' : '失败'}` }}</p>
    <p class="last" v-if="qrStatus === 2">冲单活动时间 {{activeTime[0]}}～{{activeTime[1]}}</p>
    <div class="tips">
      <div>活动结束7天后，即{{add7days}}上午0点，团油平台计算油站对应的奖励金，同时通知油站奖励金金额；</div>
      <div>活动结束7天后，即{{add7days}}上午10点，将奖励金打入到油站账户中；</div>
    </div>
    <div class="signTips" v-if="qrStatus === 2">
      <img class="img" src="https://web.nlktj.com/ty/merchant/icon-notice.png" alt=""/>
      <div>奖励金将由合作方“云账户”统一发放至您的微信零钱。根据中国法律法规，2025年10月1日起，云账户将依法履行个人所得税代扣代缴义务。金额以实际发放为准。如需了解详情可联系云账户客服400-6565-739</div>
    </div>
    <!-- <el-button type="primary" @click="$router.push({ path: '/promotion/activeList', query: { status: 30 } })">查看活动记录</el-button> -->
  </div>
</template>
<script>
import dayjs from 'dayjs'
export default {
  name: 'third',
  props: ['qrStatus', 'resultText', 'activeType', 'activeTime'], // qrStatus 2: 成功， 其他：失败
  data () {
    return {
      add7days: '',
      add14days: ''
    }
  },
  created () {
    console.log(this.activeTime)
    this.add7days = dayjs(this.activeTime[1]).add(8, 'day').format('MM月DD日')
    this.add14days = dayjs(this.activeTime[1]).add(15, 'day').format('MM月DD日')
  }
}
</script>
<style lang="less" scoped>
  .success-container {
    flex-direction: column;
    padding-top: 120px;
    img {
      width: 90px;
      height: 90px;
    }
    .first {
      color: #222222;
      font-size: 20px;
      margin-top: 20px;
      font-weight: 600;
    }
    .last {
      width: 100%;
      color: #666666;
      font-size: 16px;
      text-align: center;
    }
    .tips {
      background: #F9FAFC;
      color: #999999;
      font-size: 14px;
      padding: 16px;
      &>div:last-child {
        margin-top: 5px;
      }
    }
    .signTips{
      padding: 0 16px;
      margin-top: 16px;
      color: #f57144;
      width: 654px;
      line-height: 1.5;
      font-size: 14px;
      display: flex;
      .img{
        margin: 3px 6px 0 0;
        width: 16px;
        height: 16px;
      }
    }
    .el-button {
      width: 150px;
      margin-top: 30px;
    }
  }
</style>
